import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { TID } from "@/lib/testIds";

const scrollTo = (sel) => {
  const el = document.querySelector(sel);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer({ config, portalUrl }) {
  const co = config?.company || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid={TID.footer.root} className="relative border-t border-white/10 bg-background pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src="/vpt-logo.png" alt="VPT Engineering" className="h-12 w-auto mb-6" />
            <p className="max-w-sm text-white/50 leading-relaxed text-sm">
              Professioneller Chiptuning-Fileservice für LKW, Agrar-Nutzfahrzeuge und PKW.
              Automotive Software Solutions & Engineering aus Österreich.
            </p>
            <a
              data-testid={TID.footer.portal}
              href={portalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 bg-primary text-primary-foreground font-display font-bold uppercase tracking-wider text-sm px-6 py-3 hover:bg-white transition-colors"
            >
              Zum Fileservice-Portal <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display uppercase tracking-widest text-sm text-white mb-5">Navigation</h4>
            <ul className="space-y-3 text-sm text-white/50">
              {[
                ["Fahrzeuge", "#vehicles-section"],
                ["Leistungen", "#services-section"],
                ["Konfigurator", "#konfigurator-section"],
                ["FAQ", "#faq-section"],
                ["Kontakt", "#contact-section"],
              ].map(([label, target]) => (
                <li key={target}>
                  <button onClick={() => scrollTo(target)} className="hover:text-primary transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display uppercase tracking-widest text-sm text-white mb-5">Kontakt & Partner</h4>
            <ul className="space-y-3 text-sm text-white/50">
              <li>{co.name}</li>
              <li>{co.street}, {co.postal_code} {co.city}</li>
              <li>
                <a href={`mailto:${co.email}`} className="hover:text-primary transition-colors">{co.email}</a>
              </li>
              <li>UID: {co.vat_id}</li>
              <li className="pt-2">
                <a
                  data-testid={TID.footer.filesuite}
                  href="https://filesuite.app"
                  target="_blank"
                  rel="noopener"
                  title="FileSuite – Software-Plattform für Tuning-Fileservice"
                  className="inline-flex items-center gap-1.5 text-white/60 hover:text-accent transition-colors"
                >
                  Tuning-Software von FileSuite <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {year} {co.name}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-6 text-xs uppercase tracking-widest">
            <Link
              data-testid={TID.footer.impressum}
              to="/impressum"
              className="text-white/50 hover:text-primary transition-colors"
            >
              Impressum
            </Link>
            <Link
              data-testid={TID.footer.datenschutz}
              to="/datenschutz"
              className="text-white/50 hover:text-primary transition-colors"
            >
              Datenschutz
            </Link>
          </div>
          <p className="text-[11px] text-white/25">
            Chiptuning &amp; ECU-Files LKW · Agrar · PKW — Technologiepartner{" "}
            <a
              data-testid={TID.footer.drcoding}
              href="https://dr-coding.de"
              target="_blank"
              rel="noopener"
              title="DrCoding – ECU Coding & Software"
              className="text-white/30 hover:text-white/60 transition-colors"
            >
              DrCoding
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
